import { render, staticRenderFns } from "./ProgressComponent.vue?vue&type=template&id=8063dda4&"
import script from "./ProgressComponent.vue?vue&type=script&lang=js&"
export * from "./ProgressComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProgressComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports